module.exports = __webpack_public_path__ + "static/media/dennis_2.c8e3f065.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreWork/assets/dennis_2.png
// module id = 482
// module chunks = 0